module.exports = __webpack_public_path__ + "static/flags/BG-2ced3bbbf7ecf17357a8d1846efbc730.gif";